import { isArray } from '@lhb/func';
import { asicsBrandGather } from '../pages/costume-asics/ts-config';
export default {
    state: {
        chancepointForm: null,
        chancepointGrade: null,
        scoreDetail: null,
        asicsBrandGather: asicsBrandGather,
    },
    actions: {},
    mutations: {
        CHANCEPOINT_FORM: function (state, val) {
            state.chancepointForm = val;
        },
        CHANCEPOINT_GRADE: function (state, val) {
            state.chancepointGrade = val;
        },
        SCORE_DETAIL: function (state, val) {
            state.scoreDetail = val;
        },
        ASICS_BRAND_GATHER: function (state, val) {
            var key = val.key, value = val.value;
            if (key && isArray(value)) {
                state.asicsBrandGather.set(key, value);
            }
        },
        SET_BRAND_GATHER: function (state, val) {
            state.asicsBrandGather = val;
        },
        RESET_ASICS_BRAND_GATHER: function (state) {
            // 深拷贝
            state.asicsBrandGather = new Map(asicsBrandGather.entries());
        },
    },
    getters: {}
};
